module.exports = __webpack_public_path__ + "img/facebook.16ce5846.svg";